import { useNavigate } from "react-router-dom";
import React, { useState,useEffect }  from "react";
import Navbar from "./navbar";
import  './Resources/Actions.css';
import './App.css';

export default function Deleteexpense(){
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const [edetail, setEdetail] = useState([]);
    const [account,setAccount] = useState([]);


    useEffect(() => 
    {

    fetch(API_URL+"api/Ledger/GetAccounts")
    .then(response => response.json())
    .then(data => {setAccount(data)});
  
  
    },[])

    function expensedetail()
    {
        fetch(API_URL+"api/Expense/GetExpense?eid="+document.getElementById("enum").value).then(res=>res.json())
        .then((data)=>{setEdetail(data)});
    }

    function loadedetails()
    {   
        
        if (edetail.length > 0)
        {
            document.getElementById("edate").value = edetail[0].EntryDate.slice(0,10);
            document.getElementById("ehead").value = edetail[0].ExpenseHead;
            document.getElementById("edesc").value = edetail[0].Description;
            document.getElementById("eamount").value = edetail[0].ExpenseAmount;
        }

    }

    function deleteexpense()
    {

        const expenseaccount = account.filter((e)=>{if(e.AccountID === 8){return e;}})
        const cashaccount = account.filter((e)=>{if(e.AccountID === 3){return e;}})
        

        fetch(API_URL+"api/Expense/DeleteExpense?eid="+document.getElementById("enum").value,{method:"PUT",body:null})
        .then(res=>res.json())
        .then(()=>{});

        fetch(API_URL+"api/Ledger/UpdateCurrentDebit?id="+expenseaccount[0].AccountID+"&amount="+(expenseaccount[0].CurrentDebit-parseFloat(document.getElementById('eamount').value)),{method:"PUT",body:null})
        .then(response => response.json())
        .then(()=>{});

        fetch(API_URL+"api/Ledger/UpdateCurrentCredit?id="+cashaccount[0].AccountID+"&amount="+(cashaccount[0].CurrentCredit - parseFloat(document.getElementById('eamount').value)),{method:"PUT",body:null})
        .then(response => response.json())
        .then(()=>{});

        fetch(API_URL+"api/Ledger/DeleteAccountLedgerEntry?id="+edetail[0].CommonID,{method:"PUT",body:null})
        .then(res=>res.json())
        .then(()=>{});

        

        showOKdialog();
    }

    function showOKdialog()
    {
        const dialog = document.getElementById('myDialog');
        dialog.show();
    }

    return (
        <>
        <div style={{backgroundColor:"blue", color:"white", height:"30px", width:"100%", 
            paddingTop:"10px", top :"0px", position:"relative", fontFamily:"sans-serif",
            fontSize:"18px",marginBottom:"2%"}}> 
            Delete Expense
            <Navbar/>
        </div> 
        <form>
            <fieldset>
                <label for ="enum" style={{ marginLeft: "0px" }}>Expense ID</label>
                <input id ="enum" style={{ height: "30px", width: "40%", marginLeft: "10px" }} onChange={()=>{expensedetail()}}></input>
                <button type="button" className="fetchbutton" onClick={() => {loadedetails()}} >Search</button>
            </fieldset>
            <fieldset><legend>Expense Details</legend>
        <label for="edate"style = {{marginLeft:"10%"}}>Date</label> <br/>
        <input id ="edate" type="date" defaultValue ={new Date().toISOString().slice(0,10)} style = {{height:"30px",width:"80%",marginLeft:"10%",marginBottom:"20px"}}></input><br/>
        <label for="ehead"style = {{marginLeft:"10%"}}>Expense head</label><br/>
        <input id="ehead"style = {{height:"30px",width:"80%",marginLeft:"10%",marginBottom:"20px"}}></input><br/>
        <label for="edesc"style = {{marginLeft:"10%"}}>Expense Description</label><br/>
        <input id="edesc"style = {{height:"30px",width:"80%",marginLeft:"10%",marginBottom:"20px"}}></input><br/>
        <label for="eamount"style = {{marginLeft:"10%"}}>Expense Amount </label><br/>
        <input id ="eamount"style = {{height:"30px",width:"80%",marginLeft:"10%",marginBottom:"20px"}}></input><br/>
        </fieldset>
        <button className="actionbuttons" type="submit" onClick={()=>{deleteexpense()}}>Delete</button>
        <button className="actionbuttons" style ={{backgroundColor:"red"}} type="submit" onClick={()=>{navigate('/changes')}}>Cancel</button>
        </form>
        <dialog id="myDialog" className="okdialog"><p>Expense deleted</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/changes')}}>OK</button>
        </dialog>
        </>
    )
}